import { render, staticRenderFns } from "./dataRetrieval.vue?vue&type=template&id=11e5770e"
import script from "./dataRetrieval.vue?vue&type=script&lang=js"
export * from "./dataRetrieval.vue?vue&type=script&lang=js"
import style0 from "./dataRetrieval.vue?vue&type=style&index=0&id=11e5770e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports